var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7555_4184",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7555_4184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.49994H3.2L7.5125 5.18744L6.8125 4.48744L2.5 8.79994V9.49994ZM9.65 4.46244L7.525 2.36244L8.225 1.66244C8.41667 1.47077 8.65217 1.37494 8.9315 1.37494C9.2105 1.37494 9.44583 1.47077 9.6375 1.66244L10.3375 2.36244C10.5292 2.55411 10.6292 2.78544 10.6375 3.05644C10.6458 3.32711 10.5542 3.55827 10.3625 3.74994L9.65 4.46244ZM2 10.4999C1.85833 10.4999 1.73967 10.4519 1.644 10.3559C1.548 10.2603 1.5 10.1416 1.5 9.99994V8.58744C1.5 8.52077 1.5125 8.45627 1.5375 8.39394C1.5625 8.33127 1.6 8.27494 1.65 8.22494L6.8 3.07494L8.925 5.19994L3.775 10.3499C3.725 10.3999 3.66883 10.4374 3.6065 10.4624C3.54383 10.4874 3.47917 10.4999 3.4125 10.4999H2Z",
    fill: "#008FED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencil-edit.6002ffdacf91642408a73018d67219c2.svg";
export { ForwardRef as ReactComponent };